import { render, staticRenderFns } from "./ExtrasPage.vue?vue&type=template&id=6501bf27&scoped=true&"
import script from "./ExtrasPage.vue?vue&type=script&lang=js&"
export * from "./ExtrasPage.vue?vue&type=script&lang=js&"
import style0 from "./ExtrasPage.vue?vue&type=style&index=0&id=6501bf27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501bf27",
  null
  
)

export default component.exports